import { IsInt, IsNotEmpty, IsNumber, IsPositive, IsString } from 'class-validator'

export class Comment {
  id!: number
  harvestTeamId!: number
  type!: {
    id: number
    name: string | undefined
  }
  startDate!: Date
  endDate!: Date
  comment!: string
}

export class CommentDto {
  @IsNotEmpty()
  @IsString()
  comment!: string

  @IsNotEmpty()
  startDate!: Date

  @IsNotEmpty()
  endDate!: Date

  @IsNotEmpty()
  @IsNumber()
  harvestTeamId!: number

  @IsNotEmpty()
  @IsInt()
  @IsPositive()
  typeId!: number
}
